export default "__VITE_ASSET__61846283__"